import LoadingScreen from 'app/components/LoadingScreen'
import DodoablesList from 'app/dodoables/list/Index'
import useDodoableCollectionQuery from 'generated/api/dodoables/useDodoableCollectionQuery'

export default () => {
  const { isPending, data: { dodoables } = {} } = useDodoableCollectionQuery({
    query: { active: true, freeable: true }
  })

  const grouped = useMemo(() => {
    if (!dodoables) return null

    const innerGrouped = {}

    dodoables.forEach((dodoable) => {
      if (!innerGrouped[dodoable.freeableGroup])
        innerGrouped[dodoable.freeableGroup] = []

      innerGrouped[dodoable.freeableGroup].push(dodoable)
    })

    return innerGrouped
  }, [dodoables])

  if (isPending) return <LoadingScreen />
  const groups = Object.keys(grouped).sort()

  return (
    <div className="fcol flex-1" style={{ overflowY: 'auto' }}>
      <div className="fcol flex-1">
        {groups.map((group) => {
          return (
            <div key={group} className="mb-2">
              <div className="separator">{group}</div>
              <DodoablesList dodoables={grouped[group]} scroll={false} />
            </div>
          )
        })}
      </div>
    </div>
  )
}
